import { HELP_SOCIAL_LINKS } from '@/config/help-center';

import { MARKET_TYPE_GUIDE_QUERY } from '@/constants/market-type-guide.js';

/** 页脚操作指引：充值 / 提现 / 创建盘口 */
export const SITE_FOOTER_GUIDE_LINKS = [
  {
    to: {
      path: '/create-market/type-guide',
      query: { type: MARKET_TYPE_GUIDE_QUERY.REFILL },
    },
    labelKey: 'siteFooter.guideRefill',
  },
  {
    to: {
      path: '/create-market/type-guide',
      query: { type: MARKET_TYPE_GUIDE_QUERY.WITHDRAWAL },
    },
    labelKey: 'siteFooter.guideWithdrawal',
  },
  {
    to: {
      path: '/create-market/type-guide',
      query: { type: MARKET_TYPE_GUIDE_QUERY.BINARY },
    },
    labelKey: 'siteFooter.guideCreateMarket',
  },
];

/** 页脚链接：隐私 / 条款 / 帮助中心 / 说明文档 / 市场规则 */
export const SITE_FOOTER_META_LINKS = [
  { to: '/help/doc/privacy', labelKey: 'siteFooter.privacyShort' },
  { to: '/help/doc/terms', labelKey: 'siteFooter.termsShort' },
  { to: '/help', labelKey: 'siteFooter.support.helpCenter' },
  { to: '/help/doc/documentation', labelKey: 'siteFooter.docsShort' },
  { to: '/help/market-rules', labelKey: 'siteFooter.marketRules' },
];

/** @deprecated 使用 SITE_FOOTER_META_LINKS */
export const SITE_FOOTER_META_ROW_PRIMARY = [
  { to: '/help/doc/privacy', labelKey: 'siteFooter.privacyShort' },
];

/** @deprecated 使用 SITE_FOOTER_META_LINKS */
export const SITE_FOOTER_META_ROW_SECONDARY = [
  { to: '/help/doc/terms', labelKey: 'siteFooter.termsShort' },
  { to: '/help', labelKey: 'siteFooter.support.helpCenter' },
  { to: '/help/doc/documentation', labelKey: 'siteFooter.docsShort' },
];

/** 页脚 Telegram 快捷链接池（每次进入页脚随机选一个） */
export const SITE_FOOTER_TELEGRAM_HANDLES = [
  'DeepSageSupport',
  'DeepSage_Help',
  // 'DeepSage_CS',
  // 'DeepSage_Service',
  // 'DeepSageOfficial',
  // 'DeepSageCare',
  // 'DeepSageAssist',
  // 'DeepSageTeam',
  // 'DeepSageOne',
];

export function pickRandomFooterTelegramUrl() {
  const list = SITE_FOOTER_TELEGRAM_HANDLES;
  if (!list.length) return buildFooterTelegramUrl('DeepSage_Help');
  const handle = list[Math.floor(Math.random() * list.length)];
  return buildFooterTelegramUrl(handle);
}

/** 页脚展示联系方式（邮箱 / Telegram 可跳转，其余仅展示） */
export const SITE_FOOTER_CONTACT_ICONS = [
  { key: 'email', type: 'email', labelKey: 'helpPage.hub.social.email', linkable: true },
  { key: 'telegram', type: 'telegram', labelKey: 'helpPage.hub.social.telegram', linkable: true },
  { key: 'twitter', type: 'twitter', labelKey: 'helpPage.hub.social.twitter' },
  { key: 'instagram', type: 'instagram', labelKey: 'siteFooter.social.instagram' },
  { key: 'discord', type: 'discord', labelKey: 'siteFooter.social.discord' },
  { key: 'tiktok', type: 'tiktok', labelKey: 'siteFooter.social.tiktok' },
];

export function buildFooterTelegramUrl(handle) {
  const domain = String(handle ?? '')
    .replace(/^@/, '')
    .trim();
  return `tg://resolve?domain=${encodeURIComponent(domain)}`;
}

/** @deprecated 使用 SITE_FOOTER_META_ROW_* */
export const SITE_FOOTER_BAR_LEGAL_LINKS = [
  ...SITE_FOOTER_META_ROW_PRIMARY,
  ...SITE_FOOTER_META_ROW_SECONDARY,
];

/** @deprecated 使用 SITE_FOOTER_BAR_LEGAL_LINKS */
export const SITE_FOOTER_LEGAL_LINKS = SITE_FOOTER_BAR_LEGAL_LINKS;

/** H5 底部「更多」抽屉：法律文档导航 */
export const MOBILE_MORE_LEGAL_LINKS = SITE_FOOTER_META_LINKS;

/** H5 底部「更多」抽屉：邮箱支持 */
export const MOBILE_MORE_SUPPORT_EMAIL = {
  href: HELP_SOCIAL_LINKS.email.url,
  labelKey: 'helpPage.contact.email.title',
  address: HELP_SOCIAL_LINKS.email.address,
};

/**
 * H5 底部「更多」抽屉：外部支持链接。
 * 第一项为三方在线客服（Tawk）；点击由页面拦截，不走 Telegram。
 */
export const MOBILE_MORE_SUPPORT_EXTERNAL_LINKS = [
  {
    key: 'liveChat',
    href: '#',
    labelKey: 'helpPage.contact.liveChat.title',
    openTawk: true,
  },
];

export { HELP_SOCIAL_LINKS };
